import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from '@mwe/services';

@Pipe({ name: 'envTranslate' })
export class EnvTranslatePipe implements PipeTransform {
  private translateService = inject(TranslateService);
  private environmentService = inject(EnvironmentService);

  transform(label: string, translateParams = {}): string {
    const labelWithEnv = `${label}.${this.environmentService.getPortalCustomerType()}`;
    return this.translateService.instant(labelWithEnv, translateParams);
  }
}
